import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  title: {
    // flexGrow: 1,
    justifyContent: "center",
    alignItems: "center",
  },
}));

const Header = ({ title, subtitle1, subtitle2 }) => {
  const classes = useStyles();

  return (
    <AppBar position="static">
      <Toolbar>
        <div
          style={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            padding: "5px",
          }}
        >
          <Grid container item alignItems="center" xs={12}>
            <Grid
              item
              xs={1}
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <IconButton
                onClick={() => window.open("https://traista.com/", "_self")}
              >
                <img
                  alt="Traista"
                  src={require("../assets/traista-logo.png")}
                  height="50px"
                />
              </IconButton>
            </Grid>
            <Grid item xs={10}>
              <Typography align="center" variant="h5" className={classes.title}>
                {title}
              </Typography>
              <Typography align="center" variant="h6" className={classes.title}>
                {subtitle1}
              </Typography>
              <Typography align="center" className={classes.title}>
                {subtitle2}
              </Typography>
            </Grid>
            {/* <Grid
              item
              xs={1}
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <img
                alt="TSA"
                src={require("../assets/tsa-logo.png")}
                height="50px"
              />
            </Grid> */}
          </Grid>

          {/* <Typography align="center" variant="h5" className={classes.title}>
            {title}
          </Typography>
          <Typography align="center" className={classes.title}>
            {subTitle}
          </Typography> */}
          {/* <Icon>
            <img
              src={require("../assets/tsa-logo.png")}
              height={50}
              width={50}
            />
          </Icon> */}
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/views/Header.js